<div class="container-row">
  <div class="message-container wrap">
    <ng-container *ngFor="let message of messageList">
      <div class="message">
        {{ message }}
      </div>
    </ng-container>
  </div>
  <button mat-button type="button" #dismissButton (click)="dismiss()">X</button>
</div>
